import PropTypes from 'prop-types';
import React from 'react';
import path from 'path';
import {intlShape, injectIntl} from 'react-intl';
import session from 'services/sessionService';

import events from 'lib/events';

function createLink(systemPath, hashFragment) {
  return path.join(systemPath, hashFragment);
}

class AnalysisTabs extends React.PureComponent {
  static displayName = 'AnalysisTabs';

  static propTypes = {
    disabled: PropTypes.array,
    intl: intlShape.isRequired,
    systemPath: PropTypes.string.isRequired,
    canSwitch: PropTypes.func,
  };

  static defaultProps = {
    disabled: [],
  };

  componentDidMount() {
    // Re-render on hash change so active takes effect
    this.listener = events.subscribe('hashchange', () => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    if (this.listener && this.listener.remove) {
      this.listener.remove();
    }
  }

  switchTab = link => () => {
    if (!this.props.canSwitch) {
      location.hash = link;
      return;
    }

    let res = this.props.canSwitch();

    if (!(res instanceof Promise)) {
      res = Promise.resolve(res);
    }

    return res.then(valid => {
      if (valid) {
        location.hash = link;
      }
    });
  };

  render() {
    let {formatMessage} = this.props.intl;
    const tabs = [
      ['analysis', formatMessage({id: 'general.analysis'}), p => p.canWaterTest],
      ['details', formatMessage({id: 'general.system.details'})],
      ['chemicals', formatMessage({id: 'general.product.profile'})],
      ['report-history', formatMessage({id: 'general.test.history'})],
      ['source', formatMessage({id: 'general.source.water'}), p => p.canWaterTest],
    ];

    let navLinks = tabs.map((t, i) => {
      let allowed = true;

      if (t.length === 3 && typeof t[2] === 'function') {
        allowed = t[2](session.getUser().privileges);
      }

      if (!allowed) {
        return null;
      }

      if (location.hash.indexOf(t[0]) !== -1) {
        return <a key={i} className='active'>{t[1]}</a>;
      }

      return this.props.disabled.includes(t[0]) ?
        <a key={i} className='disabled'>{t[1]}</a> :
        <a key={i} onClick={this.switchTab(createLink(this.props.systemPath, t[0]))}>{t[1]}</a>;
    });

    return <div className='row'>
      <div className='col-xs-12'>
        <nav className='navigation-tabs'>
          {navLinks}
        </nav>
      </div>
    </div>;
  }
}

export default injectIntl(AnalysisTabs);
